import PageMonitorService from './PageMonitorService'

export default PageMonitorService
